export default "__VITE_ASSET__4f0520f6__"